/**
 * L'heure affichée, à Madagascar (décision 447 du 02/11).
 *
 * Toute heure ou date montrée à l'écran, imprimée ou écrite dans un message
 * se lit à l'heure de Madagascar, quel que soit le fuseau du poste, de la
 * télé ou du serveur (le conteneur de l'API tourne en UTC). L'affichage passe
 * par `Intl` avec `timeZone` ; le découpage des journées, lui, reste dans
 * `jour-civil.ts` (décalage fixe, décision 49).
 *
 * Une règle ESLint (`afs/fuseau-madagascar`) refuse un `toLocale*String` ou un
 * `Intl.DateTimeFormat` sans `timeZone` : un écran passe par ces fonctions.
 */
/** Le fuseau métier : Madagascar, UTC+3 toute l'année. */
export const FUSEAU_MADAGASCAR = 'Indian/Antananarivo';
/** Un instant formaté à l'heure de Madagascar, en français, avec les options voulues. */
export function formaterAMadagascar(instant, options) {
    return new Intl.DateTimeFormat('fr-FR', { ...options, timeZone: FUSEAU_MADAGASCAR }).format(instant);
}
const HEURE = new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: FUSEAU_MADAGASCAR,
});
const DATE = new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: FUSEAU_MADAGASCAR,
});
/**
 * `HH:MM` à Madagascar : `2026-11-02T06:30:00Z` → `09:30`. (Le nom
 * `heureAMadagascar` est pris par `jour-civil.ts`, qui rend `AAAA-MM-JJTHH:MM`.)
 */
export function heureCourteAMadagascar(instant) {
    return HEURE.format(instant);
}
/** `JJ/MM/AAAA` à Madagascar : `2026-11-01T22:30:00Z` → `02/11/2026`. */
export function dateAMadagascar(instant) {
    return DATE.format(instant);
}
/** `JJ/MM/AAAA HH:MM` à Madagascar. */
export function dateHeureAMadagascar(instant) {
    return `${dateAMadagascar(instant)} ${heureCourteAMadagascar(instant)}`;
}
//# sourceMappingURL=fuseau.js.map